import AutosizeInput from 'react-input-autosize'

export default AutosizeInput
